import moment from 'moment-timezone'
import type { TProperty } from 'stores/fieldAssetStore/helperTypes'
import { apiFetch } from 'utils/apiFetch'
import { filterFieldAssetsByValueTypes } from 'utils/filterFieldAssetsByValueTypes'
import type { SoilProps } from '../Soil/types'

export const fetchSoilData = async (
  selectedProperty: TProperty,
  timezone: string,
): Promise<SoilProps['data']> => {
  const allPoints = Object.values(selectedProperty.points ?? {})

  const lngLats = filterFieldAssetsByValueTypes({
    fieldAssets: allPoints,
    valuesTimeseries: ['soilMoisture'],
  }).map(({ lngLat }) => lngLat)

  const precipitationLngLats = filterFieldAssetsByValueTypes({
    fieldAssets: allPoints,
    valuesTimeseries: ['precipitation'],
  }).map(({ lngLat }) => lngLat)

  const requestLngLats = [...new Set([...lngLats, ...precipitationLngLats])]
  const soilDateFrom = moment.tz(timezone).subtract(1, 'week').startOf('day')
  const soilDateTo = moment.tz(timezone).startOf('hour')

  const soilResponse = await apiFetch({
    url: '/values',
    body: {
      dateFrom: soilDateFrom.toISOString(),
      dateTo: soilDateTo.toISOString(),
      featureReferer: 'DASHBOARD' as const,
      includeSource: true,
      points: {
        lngLats: requestLngLats,
        valuesRequested: {
          soilMoisture: { preferredAggregationInterval: 'HOURLY' as const },
          precipitation: { preferredAggregationInterval: 'HOURLY' as const },
        },
      },
    },
    params: { timeout: 2 * 60 * 1000 },
  })

  const precipitationStationLngLat =
    Object.entries(soilResponse?.points ?? {}).find(
      ([, point]: [string, { values: Record<string, unknown> }]) => {
        return 'precipitation' in point.values
      },
    )?.[0] ?? null

  return {
    selectedProperty,
    timezone,
    lngLats,
    soilDateFrom,
    soilDateTo,
    soilData: soilResponse,
    precipitationStationLngLat,
  }
}
